import React, { useContext } from 'react';
import { SystemContext } from '../SystemBuilder';

const CriteriaSelection = () => {
    const sysContext = useContext(SystemContext);
    
    const critList = {
        "TeamFilters": [
            {
                type: "fav-dog",
                label: "Favorite / Underdog",
                description: "Filter games based on team's favorite or underdog status"
            },
            {
                type: "home-team-sel",
                label: "Home Team Selector",
                description: "Select specific teams to look only at home games in your system"
            },
            {
                type: "away-team-sel",
                label: "Away Team Selector",
                description: "Select specific teams to look only at away games in your system"
            }
        ],
        "LineFilters": [
            {
                type: "odds-filter",
                label: "Odds Filter",
                description: "Filter games based on odds thresholds or ranges for your bet type"
            },
            {
                type: "team-spread",
                label: "Spread Filter",
                description: "Filter games based on point spread thresholds or ranges"
            },
            {
                type: "game-totals",
                label: "Totals Filter",
                description: "Filter games based on over/under total thresholds or ranges"
            }
        ],
        "StatFilters": [
            {
                type: "avg-comp",
                label: "Compare / Combine Stats",
                description: "Create complex filters using multiple team statistics"
            },
            {
                type: "avg",
                label: "Single Stat Criteria",
                description: "Filter using individual team statistics"
            }
        ]
    };

    return (
        <div className="space-y-8">
            <div className="border-b border-gray-200 dark:border-gray-700 pb-5 flex justify-between items-start">
                <div>
                    <h2 className="text-xl font-semibold leading-6 text-gray-900 dark:text-white">Select Criteria Type</h2>
                    <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                        Choose from different types of filters to build your betting system.
                    </p>
                </div>
                <button
                    type="button"
                    onClick={() => sysContext.setStep(2)}
                    className="rounded-md bg-white dark:bg-gray-800 px-4 py-2.5 text-sm font-semibold text-gray-900 dark:text-white shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700"
                >
                    Back
                </button>
            </div>

            <div className="space-y-8">
                {/* Team Filters Section */}
                <div>
                    <h3 className="text-base font-semibold leading-7 text-gray-900 dark:text-white mb-4">
                        Team Filters
                    </h3>
                    <ul role="list" className="divide-y divide-gray-200 dark:divide-gray-700 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
                        {critList["TeamFilters"].map((filter) => (
                            <li key={filter.type}>
                                <button
                                    onClick={() => sysContext.displayCrit(`team.${filter.type}`)}
                                    className="w-full flex flex-col gap-y-1 px-4 py-4 hover:bg-gray-50 dark:hover:bg-gray-700 text-left"
                                >
                                    <div className="text-sm font-medium text-gray-900 dark:text-white">
                                        {filter.label}
                                    </div>
                                    <p className="text-sm text-gray-500 dark:text-gray-400">
                                        {filter.description}
                                    </p>
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Line Filters Section */}
                <div>
                    <h3 className="text-base font-semibold leading-7 text-gray-900 dark:text-white mb-4">
                        Line Filters
                    </h3>
                    <ul role="list" className="divide-y divide-gray-200 dark:divide-gray-700 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
                        {critList["LineFilters"].map((filter) => (
                            <li key={filter.type}>
                                <button
                                    onClick={() => sysContext.displayCrit(`line.${filter.type}`)}
                                    className="w-full flex flex-col gap-y-1 px-4 py-4 hover:bg-gray-50 dark:hover:bg-gray-700 text-left"
                                >
                                    <div className="text-sm font-medium text-gray-900 dark:text-white">
                                        {filter.label}
                                    </div>
                                    <p className="text-sm text-gray-500 dark:text-gray-400">
                                        {filter.description}
                                    </p>
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Stat Filters Section */}
                <div>
                    <h3 className="text-base font-semibold leading-7 text-gray-900 dark:text-white mb-4">
                        Stat Filters
                    </h3>
                    <ul role="list" className="divide-y divide-gray-200 dark:divide-gray-700 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
                        {critList["StatFilters"].map((filter) => (
                            <li key={filter.type}>
                                <button
                                    onClick={() => sysContext.displayCrit(`stat.${filter.type}`)}
                                    className="w-full flex flex-col gap-y-1 px-4 py-4 hover:bg-gray-50 dark:hover:bg-gray-700 text-left"
                                >
                                    <div className="text-sm font-medium text-gray-900 dark:text-white">
                                        {filter.label}
                                    </div>
                                    <p className="text-sm text-gray-500 dark:text-gray-400">
                                        {filter.description}
                                    </p>
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default CriteriaSelection;